import React, { useRef, useState } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import {
  NAME_KEY,
  PRICE_KEY,
  KIND_KEY,
  SHOW_KEY,
} from "@/lib/printess/constants";
import EditableItemProperty from "./editable_item_property";
import SaveButton from "./save_button";
import ShowButton from "./show_button";
import DragAnchor from "./drag_anchor";
import { isProductPlaceholder } from "./palette_helpers";

const ProductRow = ({ item, onClick, onSave }) => {
  const isPlaceholder = isProductPlaceholder(item);
  const [properties, setProperties] = useState({});
  const pendingChangesRef = useRef(false);
  const [isEditing, setIsEditing] = useState(false);
  console.debug("ProductRow", item.name, item.key);

  const handlePropertyChanged = (property, newValue) => {
    pendingChangesRef.current = true;
    setProperties((prev) => ({ ...prev, [property]: newValue }));
  };

  const handleSave = () => {
    onSave({ ...item, ...properties, [SHOW_KEY]: true });
    pendingChangesRef.current = false;
  };

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    setActivatorNodeRef,
  } = useSortable({ id: item.key });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const { tabIndex, ...attributesWithoutTabIndex } = attributes;

  if (item._collapsed) return null;

  return (
    <div
      key={item.key}
      data-kind={item[KIND_KEY]}
      data-show={item[SHOW_KEY]}
      onClick={onClick}
      ref={setNodeRef}
      style={style}
      onFocus={() => setIsEditing(true)}
      onBlur={() => setIsEditing(false)}
      className={`palette-row ${isEditing ? "palette-row--editing" : ""}`}
      {...attributesWithoutTabIndex}
    >
      <div className="palette-row-main">
        {!isPlaceholder && (
          <div className="palette-cell palette-cell--icon palette-drag-cell">
            <DragAnchor
              key="drag"
              ref={setActivatorNodeRef}
              {...listeners}
            />
          </div>
        )}
        {[NAME_KEY, PRICE_KEY].map((property) => (
          <div className="palette-cell" key={property} data-column={property}>
            <EditableItemProperty
              property={property}
              value={item[property]}
              onChange={(newValue) => handlePropertyChanged(property, newValue)}
              onSave={handleSave}
            />
          </div>
        ))}
        <div className="palette-cell palette-actions-cell" key="actions">
          {pendingChangesRef.current && <SaveButton doSave={handleSave} />}
          {!pendingChangesRef.current && <ShowButton item={item} />}
        </div>
      </div>
      <div className="palette-row-sub">
        <div className="palette-cell" key="description" data-column="description">
          <EditableItemProperty
            property="description"
            value={item["description"]}
            onChange={(newValue) => handlePropertyChanged("description", newValue)}
            onSave={handleSave}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductRow;
